// Снимки экранов для сверки: #…&at=2026-09-22T08:20 (время UTC) замораживает «сейчас», чтобы снимки совпадали
// попиксельно. Подключается самым первым — до кода, который читает время или память браузера.
export const shotAt: string | null = (() => {
  const m = /(?:^#|&)at=([0-9T:-]+)/.exec(decodeURIComponent(location.hash));
  const fixed = m ? Date.parse(m[1] + ':00Z') : NaN;
  if (Number.isNaN(fixed)) return null;
  const RealDate = Date;
  class FrozenDate extends RealDate {
    constructor(...a: unknown[]) {
      if (a.length) super(...(a as [string]));
      else super(fixed);
    }
    static override now(): number { return fixed; }
  }
  window.Date = FrozenDate as DateConstructor;
  try { localStorage.clear(); } catch { /* закрытое хранилище */ }
  return new RealDate(fixed).toISOString();
})();
